
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acknowledgements",
      function () {
        return require("private-next-pages/acknowledgements/index.js");
      }
    ]);
  